import React from 'react'

const ServiceRfqQuoteLayout = () => {
  return (
    <div>
      <h1>ServiceRfqQuoteLayout</h1>
    </div>
  )
}

export default ServiceRfqQuoteLayout
